export default __webpack_public_path__ + "static/media/image-five.2a7c4fbb.jpg";